import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TreatmentMessageTemplate } from '../../components/dialogs/bulk-delivery-dialog/default-messages';
import { HttpClient } from '@angular/common/http';
import { TreatmentTypeOriginalId } from '../model/treatmentType';
import { TreatmentMessageTemplateEditModel } from '../model';

const basePath = '/api/treatment-message-templates';

@Injectable({ providedIn: 'root' })
export class TreatmentMessageTemplateClient {
    private readonly _http = inject(HttpClient);

    list(treatmentTypeId: TreatmentTypeOriginalId): Observable<TreatmentMessageTemplate[]> {
        return this._http.get<TreatmentMessageTemplate[]>(`${basePath}`, {
            params: {
                treatmentTypeId,
            },
        });
    }

    save(instruction: TreatmentMessageTemplateEditModel) {
        return this._http.post(`${basePath}`, instruction);
    }

    delete(id: number) {
        return this._http.delete(`${basePath}/${id}`);
    }
}
